import axios from 'axios';
import store from '../store';
import * as R from 'ramda';

axios.interceptors.request.use(config => {
    const token = store.getters.authToken();
    if(token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => {
    console.log('interceptor:request:error', error);
    return Promise.reject(error);
});

axios.interceptors.response.use(response => {
    return response;
}, error => {
    const status = R.path(['response', 'status'], error);
    if(R.includes(status, [401, 403]) && !R.test(/\/user\/.+\/logout/g, R.pathOr('', ['response', 'config', 'url'], error))) {
        if (R.pathEq(['response', 'data', 'reason'], 'Whitelist', error)) {
            alert('No tiene permiso para acceder al sistema. Comuníquese con el proveedor.');
        }
        return store.dispatch('logout');
    }
    if(R.includes(status, [409]) && !R.test(/\/user\/.+\/logout/g, error)) {
        store.commit('SET_DUPLICATE_SESSION', true);
        return store.dispatch('logout');
    }
    return Promise.reject(error);
});

export default axios;



// WEBPACK FOOTER //
// ./src/common/axios.js